import { QueryClient } from '@tanstack/react-query';

// Single app-wide React Query client. Kept in its own module (not index.tsx) so that
// non-React code - e.g. the auth store - can import it to clear cached data on login/logout.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});
